import NeoButtonMain from "design/design_components/neo/button/NeoButtonMain.base";

/**
 * @param {{
 *  onNewSingleRule: () => void
 * }} param0 
 * @returns 
 */
export default function NewSingleRuleButton({ onNewSingleRule }) {
    return (
        <NeoButtonMain alternative="outlined" onClick={onNewSingleRule}> 
            <i className="pi pi-plus mr-6"></i>
            Crear criterio único 
        </NeoButtonMain>
    )
}